import { Service } from "../../Model";
import { BarberRepository } from "../../Repository";

export async function serviceSelected(
  service: Service,
  repository: BarberRepository
): Promise<void> {
  return repository.setSelectedService(service);
}
